import BaseApi from "./baseApi";

export default class FeedbackApi extends BaseApi {
    async addFeedback(feedback: Feedback): Promise<void> {
     
        const url = `/api/feedback/CreateFeedback`;
        const formData = new FormData();
        formData.append("type", feedback.type);
        formData.append("subType", feedback.subType);
        formData.append("description", feedback.description);
        formData.append("userId", feedback.userId);
        formData.append("userName", feedback.userName);
        formData.append("orderId", feedback.orderId);
       
        // Check if a file is provided before appending
        if (feedback.file) {
            formData.append("file", feedback.file);
        }
        if (feedback.fileName) {
            formData.append("fileName", feedback.fileName);
        }
     
        return await this.fetchPutFile(url, formData);
    }

}